import { Gallery } from '@divlab/divanui';

import * as HeaderStore from '@Stores/Header';
import { useScrollToView } from '@Hooks/useScrollToView';
import useTranslation from '@Queries/useTranslation';
import useMedias from '@Hooks/useMedias';
import Category from './elems/Category';
import ImgOne from './images/1.jpg';
import ImgTwo from './images/2.jpg';
import ImgThree from './images/3.jpg';
import ImgFour from './images/4.jpg';
import styles from './Decision.module.css';

import type { FC, HTMLAttributes } from 'react';

type DecisionProps = HTMLAttributes<HTMLDivElement>;

const Decision: FC<DecisionProps> = (props) => {
  const { isMobile } = useMedias();
  const { handleScrollTo } = useScrollToView();
  const { contentHeight } = HeaderStore.useSizes();
  const { t } = useTranslation();

  const arr = [
    { id: 'sofas', title: t('decision.blocks.sofas'), img: ImgOne },
    { id: 'tables', title: t('decision.blocks.tables'), img: ImgTwo },
    { id: 'module', title: t('decision.blocks.module'), img: ImgThree },
    { id: 'textile', title: t('decision.blocks.textile'), img: ImgFour },
  ];

  const handleClick = (id: string) => {
    const element = document.getElementById(id);

    if (!element) return;
    window.history.replaceState({}, '', `#${id}`);
    handleScrollTo(element, contentHeight);
  };

  return (
    <div {...props}>
      <div className={styles.text}>
        <h2 className={styles.title}>{t('decision.title')}</h2>
        <p className={styles.subtitle}>{t('decision.subtitle')}</p>
      </div>

      {isMobile ? (
        <div className={styles.list}>
          {arr.map((item) => (
            <Category
              key={item.id}
              id={item.id}
              img={item.img}
              title={item.title}
              className={styles.category}
              onLinkClick={handleClick}
            />
          ))}
        </div>
      ) : (
        <Gallery
          className={styles.galleryWrapper}
          cnGallery={styles.gallery}
          cnSlide={styles.slide}
          scrollbar
        >
          {arr.map((item) => (
            <Category
              key={item.id}
              id={item.id}
              img={item.img}
              title={item.title}
              onLinkClick={handleClick}
            />
          ))}
        </Gallery>
      )}
    </div>
  );
};

export default Decision;
